import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FullscreenOverlayContainer, OverlayContainer, OverlayModule } from '@angular/cdk/overlay'

import { MessengerRoutingModule } from './messenger-routing.module'
import { MessengerComponent } from './components/messenger/messenger.component'
import { ChatListComponent } from './components/chat-list/chat-list.component'
import { ChatComponent } from './components/chat/chat.component'
import { ChatDetailsComponent } from './components/chat-details/chat-details.component'
import { ChatFormComponent } from './components/chat-form/chat-form.component'
import { ChatMessageListComponent } from './components/chat-messages-list/chat-message-list.component'
import { ChatMessageComponent } from './components/chat-message/chat-message.component'
import { SharedModule } from '@shared/shared.module'
import { ChatCreateButtonComponent } from './components/chat-create-button/chat-create-button.component'
import { ChatCreateFormComponent } from './components/chat-create-form/chat-create-form.component'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { ChatToolbarComponent } from './components/chat-toolbar/chat-toolbar.component'
import { ChatDetailsUserListComponent } from './components/chat-details-user-list/chat-details-user-list.component'
import { NgScrollbarModule } from 'ngx-scrollbar'
import { ChatListTriggerDirective } from './directives/chat-list-trigger.directive'
import { ChatToolbarTemplateComponent } from './components/chat-toolbar-template/chat-toolbar-template.component'
import { ChatSearchComponent } from './components/chat-search/chat-search.component'
import { ChatToolbarListComponent } from './components/chat-toolbar-list/chat-toolbar-list.component'

@NgModule({
  declarations: [
    MessengerComponent,
    ChatListComponent,
    ChatComponent,
    ChatDetailsComponent,
    ChatFormComponent,
    ChatMessageListComponent,
    ChatMessageComponent,
    ChatCreateButtonComponent,
    ChatCreateFormComponent,
    ChatDetailsUserListComponent,
    ChatListTriggerDirective,
    ChatToolbarTemplateComponent,
    ChatToolbarComponent,
    ChatSearchComponent,
    ChatToolbarListComponent,
  ],
  imports: [CommonModule, MessengerRoutingModule, SharedModule, ScrollingModule, NgScrollbarModule, OverlayModule],
  exports: [ChatListTriggerDirective, ChatToolbarTemplateComponent, ChatToolbarComponent, ChatToolbarListComponent, ChatComponent],
  providers: [{ provide: OverlayContainer, useClass: FullscreenOverlayContainer }],
})
export class MessengerModule {}
